var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"expanding-list list-unstyled"},_vm._l((_vm.displayItems),function(item){return _c('li',{key:item},[(item === 'more ...')?_c('span',[_c('button',{staticClass:"linkButton passwordLink",on:{"click":_vm.clickMore}},[_vm._v(_vm._s(item))])]):_c('span',[_vm._v(_vm._s(item))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c846cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExpandingList.vue
// module id = null
// module chunks = 